import React from 'react';
import { LayoutDashboardIcon, TicketIcon, ClockIcon, UsersIcon, BarChart3Icon, BookOpenIcon, ShieldIcon, SettingsIcon } from 'lucide-react';
interface SidebarProps {
  activePage: string;
  onNavigate: (page: string) => void;
}
export function Sidebar({
  activePage,
  onNavigate
}: SidebarProps) {
  const navItems = [{
    name: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    name: 'Tickets',
    icon: TicketIcon
  }, {
    name: 'SLA Monitor',
    icon: ClockIcon
  }, {
    name: 'Team',
    icon: UsersIcon
  }, {
    name: 'Analytics',
    icon: BarChart3Icon
  }, {
    name: 'Knowledge Base',
    icon: BookOpenIcon
  }];
  return <div className="w-64 bg-slate-900 text-white flex flex-col h-full min-h-screen" data-id="element-45">
      <div className="p-6 flex items-center space-x-3 border-b border-slate-800" data-id="element-46">
        <div className="bg-blue-500 p-2 rounded-lg" data-id="element-47">
          <ShieldIcon className="w-6 h-6 text-white" data-id="element-48" />
        </div>
        <span className="text-xl font-bold tracking-tight" data-id="element-49">
          IT Support Center
        </span>
      </div>

      <div className="flex-1 py-6 px-4 space-y-1" data-id="element-50">
        {navItems.map(item => <button key={item.name} onClick={() => onNavigate(item.name)} className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${activePage === item.name ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} data-id="element-51">
            <item.icon className="w-5 h-5" data-id="element-52" />
            <span className="font-medium" data-id="element-53">{item.name}</span>
          </button>)}
      </div>

      <div className="p-4 border-t border-slate-800" data-id="element-54">
        <button className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-slate-300 hover:bg-slate-800 hover:text-white transition-colors mb-2" data-id="element-55">
          <SettingsIcon className="w-5 h-5" data-id="element-56" />
          <span className="font-medium" data-id="element-57">Settings</span>
        </button>
        <div className="flex items-center space-x-3 px-4 py-3 mt-2" data-id="element-58">
          <div className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center text-lg font-bold text-slate-300" data-id="element-59">
            AU
          </div>
          <div className="flex flex-col text-left" data-id="element-60">
            <span className="text-sm font-medium text-white" data-id="element-61">Admin User</span>
            <span className="text-xs text-slate-400" data-id="element-62">IT Manager</span>
          </div>
        </div>
      </div>
    </div>;
}